import CustomFetch from "components/API/customFetch";

export const getGoals = async (referenceMonth) => {
  const url = new URL(`${process.env.REACT_APP_API}/Goals`);

  if (referenceMonth != null) {
    url.searchParams.append("referenceMonth", referenceMonth);
  }

  const response = await CustomFetch(url, { method: "GET" });

  if (!response.ok) {
    throw new Error("Erro ao carregar metas.");
  }

  return response.json();
};

export const createGoal = async (requestBody) => {
  const response = await CustomFetch(`${process.env.REACT_APP_API}/Goals`, {
    method: "POST",
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error("Erro ao adicionar meta.");
  }

  return response.json();
};

export const updateGoal = async (id, requestBody) => {
  const response = await CustomFetch(`${process.env.REACT_APP_API}/Goals/${id}`, {
    method: "PUT",
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error("Erro ao salvar meta.");
  }

  return response.json();
};

export const deleteGoal = async (id) => {
  const response = await CustomFetch(`${process.env.REACT_APP_API}/Goals/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Erro ao remover meta.");
  }

  return true;
};
